import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { firebaseConfig } from "@/constants";

// mutation types
export const LOG_EVENT = "logEvent";

const app = initializeApp(firebaseConfig);
const state = {
    fireApp: app,
    analytics: getAnalytics(app)
};

const getters = {
    fireApp(state) {
        return state.user;
    },
    analytics(state) {
        return state.isAuthenticated;
    }
};

const actions = {}

const mutations = {
    [LOG_EVENT](state, event) {
        logEvent(state.analytics, event.name, event.data);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
